function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export var TokenUtils = /*#__PURE__*/ function() {
    "use strict";
    function TokenUtils() {
        _class_call_check(this, TokenUtils);
    }
    _create_class(TokenUtils, null, [
        {
            key: "getRefreshToken",
            value: function getRefreshToken() {
                var refreshToken = null;
                var authToken = TokenUtils.getAuthToken();
                if (authToken !== null) {
                    refreshToken = authToken.refresh_token;
                }
                return refreshToken;
            }
        },
        {
            key: "saveRefreshToken",
            value: function saveRefreshToken(refreshToken) {
                var authToken = TokenUtils.getAuthToken();
                if (authToken !== null) {
                    authToken.refresh_token = refreshToken;
                }
            }
        },
        {
            key: "isTokenExpired",
            value: function isTokenExpired() {
                var isExpired = true;
                var authToken = TokenUtils.getAuthToken();
                if (authToken !== null) {
                    var now = new Date();
                    var expires = new Date(authToken['.expires']);
                    isExpired = expires <= now;
                }
                return isExpired;
            }
        },
        {
            key: "saveAuthToken",
            value: function saveAuthToken(authToken) {
                window.localStorage.setItem(TokenUtils.AUTH_TOKEN_KEY, JSON.stringify({
                    authToken: authToken
                }));
            }
        },
        {
            key: "removeAuthToken",
            value: function removeAuthToken() {
                window.localStorage.removeItem(TokenUtils.AUTH_TOKEN_KEY);
            }
        },
        {
            key: "saveJwtToken",
            value: function saveJwtToken(jwtToken) {
                window.localStorage.setItem(TokenUtils.JWT_TOKEN_KEY, jwtToken);
            }
        },
        {
            key: "removeJwtToken",
            value: function removeJwtToken() {
                window.localStorage.removeItem(TokenUtils.JWT_TOKEN_KEY);
            }
        },
        {
            key: "getAuthToken",
            value: function getAuthToken() {
                var authToken = null;
                var storedAuthToken = window.localStorage.getItem(TokenUtils.AUTH_TOKEN_KEY);
                if (storedAuthToken !== null) {
                    try {
                        var parsedAuthToken = JSON.parse(storedAuthToken).authToken;
                        if (parsedAuthToken) {
                            authToken = parsedAuthToken;
                        }
                    } catch (error) {
                        console.error('Could not parse token!');
                    }
                }
                return authToken;
            }
        }
    ]);
    return TokenUtils;
}();
_define_property(TokenUtils, "AUTH_TOKEN_KEY", 'authToken');
_define_property(TokenUtils, "JWT_TOKEN_KEY", 'jwt');
